import React, { ReactElement, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Transfer, Modal, Button, Space, ConfigProvider } from 'antd'
import type { TransferDirection } from 'antd/es/transfer'
import zhCN from 'antd/es/locale/zh_CN'
import { useTranslation } from 'react-i18next'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import { IBu } from '@/store/models/auth.model'
import { getBUList } from '@/services/progress.service'

function SelectBU ({
    show, setShow, confirm, title, selectedKeysData
}: {
    show: boolean
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    setShow: (b: boolean) => void
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    confirm: (users: IBu[]) => void
    selectedKeysData?: string[]
    title: string
}): ReactElement {
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const location = useLocation()
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()
    const [targetKeys, setTargetKeys] = useState<string[]>([])
    const [selectedKeys, setSelectedKeys] = useState<string[]>([])
    const [isModalOpen, setIsModalOpen] = useState(false)
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [userLs, setUserLs] = useState<IBu[]>([])

    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const onChange = (nextTargetKeys: string[], direction: TransferDirection, moveKeys: string[]) => {
        setTargetKeys(nextTargetKeys)
    }
    const onSelectChange = (sourceSelectedKeys: string[], targetSelectedKeys: string[]) => {
        setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys])
    }
    const onConfirm = () => {
        const res = userLs.filter(item => targetKeys.includes('' + item.id))
        confirm(res)
        closePop()
    }
    const closePop = () => {
        setShow(false)
    }
    useEffect(() => {
        if (selectedKeysData && selectedKeysData.length > 0) {
            setTargetKeys(selectedKeysData.map(item => item.toString()))
        }else {
            setTargetKeys([])
        }
    }, [selectedKeysData])

    const getUserLs = async () => {
        try {
            const res = await getBUList()
            setUserLs(res)
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    useEffect(() => {
        getUserLs()
    }, [])
    
    useEffect(() => {
        setIsModalOpen(show)
    }, [show])

    return (
        (<Modal title={title} open={isModalOpen} 
            onOk={closePop}
            onCancel={closePop}
            width='90%'
            centered
            footer={[
                <Button key="confirm" type="primary" onClick={onConfirm}>{t('confirm')}</Button>,
                <Button key="close" onClick={closePop}>{t('close')}</Button>
            ]}
        >
            <Space direction='vertical' style={{ width: '100%' }}>
                <ConfigProvider locale={i18n.language === 'zh' ? zhCN : undefined}>
                    <Transfer
                        style={{ width: '100%' }}
                        listStyle={{ flex: 1 }}
                        dataSource={userLs}
                        titles={[t('Source'), t('Target')]}
                        rowKey={record => '' + record.id}
                        targetKeys={targetKeys}
                        selectedKeys={selectedKeys}
                        onChange={onChange}
                        onSelectChange={onSelectChange}
                        render={item => item.bu}
                    />
                </ConfigProvider>
            </Space>
        </Modal>)
    );
}

export default SelectBU
